import PermissionGate from '../components/PermissionGate';
import React, {useState} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faCartArrowDown, faChartPie, faChevronDown, faClipboard, faCommentDots, faFileAlt, faPlus, faRocket, faStore } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Button, Dropdown, OverlayTrigger, Tooltip } from '@themesberg/react-bootstrap';
import { ChoosePhotoWidget, ProfileCardWidget } from "../components/Widgets";
import { GeneralInfoForm } from "../components/Forms";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from '@themesberg/react-bootstrap';

import { PageTrafficTable, RankingTable } from "../components/Tables";

import { Link } from 'react-router-dom';

import Profile3 from "../assets/img/team/profile-picture-3.jpg";


export default ({ onDownload }) => {

  const [exportHandlers, setExportHandlers] = useState({});

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

  const disableDownload = !isLoggedInSuperOrAdmin;

  const handleDownloadClick = (type) => {
    if (type === "pdf") {
      exportHandlers.exportAsPDF && exportHandlers.exportAsPDF();
    } else if (type === "xml") {
      exportHandlers.exportAsXML && exportHandlers.exportAsXML();
    }
  };

  return (
    <>

      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">

        <div className="my-auto">
          <h2 className="page-breadcrumb">Customers</h2>
        </div>

<div className="d-flex gap-2">
          {/* Download button */}
          {/* <Dropdown>
            <Dropdown.Toggle
              variant="outline-primary"
              className="d-inline-flex align-items-center py-2 px-3"
              // disabled={disableDownload}
            >
              Download Customers Data
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDownloadClick("pdf")}>
                Download as PDF
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDownloadClick("xml")}>
                Download as XML
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          {/* {!isLoggedInSuperOrAdmin ? (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-disabled">Only Admin, Super Admin and Internal Sales can download customer data</Tooltip>}
            >
              <span className="d-inline-block">
                <Button
                  variant="outline-primary"
                  style={{ cursor: "not-allowed", opacity: 0.65, pointerEvents: "none" }}
                >
                  Download Customers Data
                </Button>
              </span>
            </OverlayTrigger>
          ) : (
            <Dropdown>
              <Dropdown.Toggle variant="outline-primary">
                Download Customers Data
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleDownloadClick("pdf")}>Download as PDF</Dropdown.Item>
                <Dropdown.Item onClick={() => handleDownloadClick("xml")}>Download as XML</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )} */}
          {isLoggedInSuperOrAdmin && (
            <Dropdown>
              <Dropdown.Toggle variant="outline-primary">
                Download Customers Data
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleDownloadClick("pdf")}>
                  Download as PDF
                </Dropdown.Item>
                <Dropdown.Item onClick={() => handleDownloadClick("xml")}>
                  Download as XML
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

        <PermissionGate module="customers" action="add"><Link to="/create-customers">
          <Button variant="primary" className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 btn btn-primary box-shedow-none outline-none btn btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            Create Customer
          </Button>
        </Link></PermissionGate>
</div>
      </div>

      <div className="my-auto">
        {/* <PageTrafficTable /> */}
        <PageTrafficTable onDataLoaded={(data, handlers) => setExportHandlers(handlers)} />
      </div>

    </>
  );
};
